import { ApplicationsErrorCode, createApplicationsError, } from './ApplicationsError';
export class Application {
    constructor(appDefinitionId) {
        this.appDefinitionId = appDefinitionId;
        this.pendingWaiters = [];
    }
    setApplication(instance) {
        this.application = instance;
        this.pendingWaiters.forEach((res) => res(this));
        this.pendingWaiters = [];
    }
    ensureApplication() {
        if (!this.application) {
            throw createApplicationsError(ApplicationsErrorCode.ApplicationIsNotReady).withApplicationId(this.appDefinitionId);
        }
        return this.application;
    }
    async getPublicAPI() {
        return this.ensureApplication().getPublicAPI();
    }
    async getPrivateAPI() {
        return this.ensureApplication().getPrivateAPI();
    }
    waitReady() {
        return new Promise((res) => {
            if (this.application) {
                return res(this);
            }
            this.pendingWaiters.push(res);
        });
    }
}
//# sourceMappingURL=Application.js.map